    <div class="low-navbar-account">
        <ul>
            @for(item of navItems; track item.item){
                <li [ngClass]="{'nav-item-active' : item.active, 'nav-item': !item.active}">
                    <a (click)="triggerAction(item.item)">{{ item.name }}</a>
                </li>
            }
        </ul>
        <hr>
    </div>

    <app-nav-members *ngIf="navItems[0].active"></app-nav-members>
    <app-activities *ngIf="navItems[1].active"></app-activities>

